import type { BoxProps } from '@chakra-ui/react'
import { IconButton } from '@chakra-ui/react'
import type { FC } from 'react'
import { useState } from 'react'
import { useCallback } from 'react'

import ConfirmPopover from '@app/shared/confirmPopover'
import { useStore } from '@app/store'
import ICON_MAP from '@app/utils/iconMap'

type Props = Partial<BoxProps> & {
  chat: Parameters<ReturnType<typeof useStore.use.deleteObject>>[0]
  onConfirm?: () => void
}

const ChatDeleteButton: FC<Props> = ({ chat, onConfirm: propOnConfirm, ...boxProps }) => {
  const deleteObject = useStore.use.deleteObject()
  const [loading, setLoading] = useState(false)

  const onConfirm = useCallback(async () => {
    setLoading(true)
    let result = null

    try {
      result = await deleteObject(chat)
      propOnConfirm?.()
    } finally {
      setLoading(false)
    }

    return result
  }, [propOnConfirm, chat, deleteObject])

  return (
    <ConfirmPopover
      onConfirm={onConfirm}
      header="Delete chat"
      body="Are you sure? You can&#39;t undo this action afterwards."
      confirmButtonText="Delete"
      loading={loading}
      {...boxProps}
    >
      <IconButton loading={loading} aria-label="Delete chat" variant="ghost">
        <ICON_MAP.Delete />
      </IconButton>
    </ConfirmPopover>
  )
}

export default ChatDeleteButton
